export default "__VITE_ASSET__jPpGMOx1__"